<template>
  <div class="wrapper">
    <the-nav-bar :title="$t('payInfo.settings[1].title')" />
    <div class="body-wrapper">
      <md-field v-for="item in payInfoList" :key="item.id">
        <div class="field-header-title row-align-center" slot="header">
          <img
            class="pay-icon"
            :src="getPayIcon(item.method)"
            :alt="getPayName(item.method)"
          />
          <span class="pay-name">{{ getPayName(item.method) }}</span>
        </div>
        <div class="field-header-action" slot="action" @click="goEdit(item)">
          <span>{{ $t('payInfo.edit') }}</span>
        </div>
        <md-detail-item
          :title="$t('payInfo.trueName')"
          :content="item.trueName"
        ></md-detail-item>
        <md-detail-item
          v-if="'alipay' === item.method"
          :title="$t('payInfo.alipayAccount')"
          :content="item.account"
        ></md-detail-item>
        <md-detail-item
          v-if="'wechatpay' === item.method"
          :title="$t('payInfo.wechatAccount')"
          :content="item.account"
        ></md-detail-item>
        <md-detail-item
          v-if="'bank' === item.method"
          :title="$t('payInfo.bankAccount')"
          :content="item.account"
        ></md-detail-item>
        <md-detail-item
          v-if="'bank' === item.method"
          :title="$t('payInfo.bankName')"
          :content="`${item.address1} ${item.address2}`"
        ></md-detail-item>
        <div class="field-footer row-justify" slot="footer">
          <div class="field-footer-left" @click="onCheck(item)">
            <md-radio
              icon="icon-trader-selected"
              icon-inverse="icon-trader-unselected"
              iconSvg
              v-model="defaultChecked"
              :name="item.id"
              :label="$t('payInfo.default')"
            ></md-radio>
          </div>
          <div class="field-footer-right" @click="onChangeSwitch(item)">
            <md-switch v-model="switchMap[item.id]"></md-switch>
          </div>
        </div>
      </md-field>
    </div>
    <div class="footer-wrapper">
      <md-button
        type="primary"
        @click="goPayInfoAdd"
      >
        <span>{{ $t('payInfo.addPayment') }}</span>
      </md-button>
    </div>
  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import {
  Field,
  DetailItem,
  Button,
  Dialog,
  Toast,
  Radio,
  Switch,
} from 'mand-mobile';
import getPayIcon from '@/utils/get-payment-icon.js';
import { mapState } from 'vuex';
import { putUserPayDefault, putUserPayShow } from '@/api/user';
export default {
  components: {
    TheNavBar,
    [Field.name]: Field,
    [DetailItem.name]: DetailItem,
    [Button.name]: Button,
    [Radio.name]: Radio,
    [Switch.name]: Switch,
  },
  data() {
    return {
      isSyncing: false,
      defaultChecked: '',
      switchMap: {},
    };
  },
  computed: mapState({
    userInfo: state => state.userInfo,
    payInfoList: state => state.payInfoList,
  }),
  mounted() {
    this.$store
      .dispatch('updatePayInfo')
      .then(() => {
        this.payInfoList.forEach(item => {
          if (item.isDefault) {
            this.defaultChecked = item.id;
          }
          this.$set(this.switchMap, item.id, item.isShow);
        });
      })
      .catch(err => {
        Toast.failed(err.message);
      });
  },
  methods: {
    getPayIcon(payment) {
      const map = {
        wechatpay: 'wechatpay',
        alipay: 'alipay',
        bank: 'unionpay',
      };
      return getPayIcon(map[payment]);
    },
    getPayName(payment) {
      const map = {
        wechatpay: 'wechatpay',
        alipay: 'alipay',
        bank: 'unionpay',
      };
      return this.$t(`payments.${map[payment]}`);
    },
    goDetail(payMethod) {
      this.$router.push({
        path: '/mine/payInfo/list/detail',
        query: {
          payMethod,
        },
      });
    },
    goEdit(item) {
      this.$router.push({
        path: '/mine/payInfo/list/detail',
        query: {
          id: item.id,
          payMethod: item.method,
        },
      });
    },
    goPayInfoAdd() {
      this.$router.push('/mine/payInfo/list/add');
    },
    onCheck(item) {
      if (item.id != this.defaultChecked) {
        Dialog.confirm({
          icon: '',
          title: this.$t('payInfo.setDefault', {
            payMethod: `${this.getPayName(item.method)} ${item.account}`,
          }),
          cancelText: this.$t('common.cancel'),
          confirmText: this.$t('common.confirm'),
          onConfirm: () => {
            Toast.loading(this.$t('common.loading'));
            putUserPayDefault(item.id, true)
              .then(() => {
                return this.$store.dispatch('updatePayInfo');
              })
              .then(() => {
                Toast.hide();
                this.defaultChecked = item.id;
              })
              .catch(err => {
                Toast.failed(err.message);
              });
          },
        });
      } else {
        // 取消设置
        Dialog.confirm({
          icon: '',
          title: this.$t('payInfo.cancelDefault'),
          cancelText: this.$t('common.no'),
          confirmText: this.$t('common.yes'),
          onConfirm: () => {
            Toast.loading(this.$t('common.loading'));
            putUserPayDefault(item.id, false)
              .then(() => {
                return this.$store.dispatch('updatePayInfo');
              })
              .then(() => {
                Toast.hide();
                this.defaultChecked = '';
              })
              .catch(err => {
                Toast.failed(err.message);
              });
          },
        });
      }
    },
    onChangeSwitch(item) {
      let isShow = !this.switchMap[item.id];
      let msg = isShow
        ? this.$t('payInfo.switchOpened')
        : this.$t('payInfo.switchClosed');
      putUserPayShow(item.id, isShow)
        .then(() => {
          this.switchMap[item.id] = isShow;
          Toast.succeed(msg);
        })
        .catch(err => {
          Toast.failed(err.message);
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
.wrapper {
  background: #F8FBFC;
}

.body-wrapper {
  padding-bottom: 60vw;
  background: #F8FBFC;
}

.md-field {
  margin: 2.13vw 0 0;
  padding: 0;

  & >>> {
    .md-field-header {
      position: relative;
      margin: 0;
      padding: 4.8vw;
      line-height: 6.4vw;
      hairline(bottom, #eaf1f3);
    }

    .md-field-content {
      padding: 2.13vw 4.8vw 4.8vw;
    }

    .md-detail-title {
      font-size: 3.2vw;
      color: #2c3133;
    }

    .md-detail-content {
      font-size: 3.2vw;
      font-weight: 600;
      color: #84969c;
    }

    .md-field-footer {
      margin-top: 0;
    }
  }

  .field-header-title {
    .pay-icon {
      width: 6.4vw;
      height: 6.4vw;
    }

    .pay-name {
      margin-left: 2.13vw;
      font-size: 3.73vw;
      font-weight: bold;
    }
  }

  .field-header-action {
    font-size: 3.2vw;
    color: color-primary;
  }

  .field-footer {
    padding: 0 4.8vw 4.8vw;

    .field-footer-left {
      & >>> {
        .md-radio {
          pointer-events: none;
        }
      }
    }

    .field-footer-right {
      & >>> {
        .md-switch {
           pointer-events: none;
        }
      }
    }
  }
}

.footer-wrapper {
  position: fixed;
  left: 4.8vw;
  right: 4.8vw;
  bottom: 0;
  bottom: constant(safe-area-inset-bottom); /* iOS 11.0 */
  bottom: env(safe-area-inset-bottom); /* iOS 11.2 */
  z-index: 100;

  .md-button {
    margin-bottom: 4.8vw;
  }
}
</style>
